/**
 * جابه‌جاییِ تمرکز روی بادبزنِ دست.
 *
 * جدا و خالص نوشته شده تا بی‌مرورگر آزموده شود؛ سیمِ DOMش در `TableView` است.
 *
 * جهت‌ها **فیزیکی**‌اند و نه متنی: کارتِ j-اُم با x بزرگ‌تر رسم می‌شود
 * (`playerHandTarget`)، پس «راست» یعنی اندیسِ بالاتر، هرچند صفحه راست‌به‌چپ
 * است. دست یک ردیفِ کارت روی میز است، نه یک خطِ نوشته.
 */
export function nextHandIndex(cur: number, key: string, n: number): number | null {
  if (n <= 0) return null;
  switch (key) {
    case "ArrowRight": return Math.min(n - 1, cur + 1);
    case "ArrowLeft":  return Math.max(0, cur - 1);
    case "ArrowUp":    return Math.max(0, cur - 1);
    case "ArrowDown":  return Math.min(n - 1, cur + 1);
    case "Home":       return 0;
    case "End":        return n - 1;
    default:           return null;
  }
}

/** کلیدهایی که یعنی «همین را بزن». */
export function isPickKey(key: string): boolean {
  return key === "Enter" || key === " " || key === "Spacebar";
}
